<template>
  <v-card max-height="90%">
    <v-card-title class="text-subtitle-1 text-wrap font-weight-bold mb-2">
      {{ currentSong.title }}
    </v-card-title>
    <v-card-text>
      <div v-if="currentSong.themes && currentSong.themes.length" class="mb-1">
        <v-chip
          v-for="theme in currentSong.themes"
          :key="theme"
          size="small"
          variant="tonal"
          class="mr-1 mb-1"
        >{{ theme }}</v-chip>
      </div>
      <v-container class="pa-0" :class="currentSong.themes && currentSong.themes.length ? 'pt-4' : 'mt-n4'">
        <v-row>
          <v-col class="pa-0">
            <v-textarea
              :model-value="currentSong.sequence"
              auto-grow
              rows="1"
              label="Sequence"
              readonly
              density="compact"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row class="mt-n2 pa-0">
          <v-col class="pa-0">
            <v-textarea
              :model-value="currentSong.lyrics"
              auto-grow
              label="Lyrics"
              readonly
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row class="mt-n2 pa-0">
          <v-col class="d-flex justify-center">
            <v-btn @click="copyToClipboard" variant="tonal"
              >Copy To Clipboard</v-btn
            >
            &nbsp;
            <v-btn @click="closeLyrics" variant="tonal">Close</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-snackbar v-model="snackbarVisible">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbarVisible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
export default {
  props: {
    currentSong: Object,
  },
  data: function () {
    return {
      snackbarText: "",
      snackbarVisible: false,
    };
  },
  computed: {
    clipboardText: function () {
      var song = this.currentSong || {};
      return [song.title, song.lyrics].filter(Boolean).join("\n\n");
    },
  },
  methods: {
    message: function (message) {
      this.snackbarText = message;
      this.snackbarVisible = true;
    },
    closeLyrics: function () {
      this.$emit("close");
    },
    copyToClipboard: function () {
      var self = this;
      navigator.clipboard.writeText(this.clipboardText).then(
        function () {
          self.message("Copied to clipboard.");
        },
        function (err) {
          self.message("Copy failed: " + err.message);
        }
      );
    },
  },
};
</script>
